import { useEffect, useMemo, useState } from "react";
import useApi from "../useApi";
import { Option } from "../../common/commonSelect";
import webservice_url from "../../webservice/Webservice_url";

interface DataTypes {
    org_id: string;
    name: string;
    user_id: string;
}

// ========= Admin PORTAL ===========
export function useOrganizations() {
    const [dataList, setDataList] = useState<DataTypes[]>([]);

    // API
    const { callApi, loading, error } = useApi<any>(webservice_url.get_organization, {
        method: "GET",
        autoCall: false,
        handleGlobalError: false,
    });

    const options = useMemo<Option[] | []>(() => {
        if (!dataList?.length) return [];

        return dataList?.map((d) => ({
            label: d?.name ?? "",
            value: d?.org_id ?? "",
        }))
    }, [dataList])

    //   fetch data 
    const fetchData = async () => {
        try {
            const res = await callApi();
            setDataList(Array.isArray(res) ? res : (res?.data ?? []));
        } catch (err: any) {
            console.error(err)
            setDataList([]);
        }
    }

    useEffect(() => {
        fetchData()
    }, [])

    return { dataList, options, loading, fetchData };
}

// organization by managerId 
export function useOrganizationsByManagerId(managerId: string) {
    const [dataList, setDataList] = useState<DataTypes[]>([]);

    // API
    const { callApi, loading, error } = useApi<any>(webservice_url.get_organization_by_managerId, {
        method: "POST",
        autoCall: false,
        handleGlobalError: false,
    });

    const options = useMemo<Option[] | []>(() => {
        if (!dataList?.length) return [];

        return dataList?.map((d) => ({
            label: d?.name ?? "",
            value: d?.org_id ?? "",
        }))
    }, [dataList])

    //   fetch data 
    const fetchData = async () => {
        try {
            const res = await callApi({
                manager_id: managerId ?? ""
            });
            setDataList(Array.isArray(res) ? res : (res?.data ?? []));
        } catch (err: any) {
            console.error(err)
            setDataList([]);
        }
    }

    useEffect(() => {
        if (!managerId) return;
        fetchData()
    }, [managerId])

    return { dataList, options, loading };
}
// ========= END Admin PORTAL ===========

// ========= VERIFIER PORTAL ===========
export function useOrganizations_Verifier() {
    const [dataList, setDataList] = useState<DataTypes[]>([]);

    const { callApi, loading } = useApi<any>(
        webservice_url.fetchOrganizations,
        {
            method: "GET",
            autoCall: false,
            handleGlobalError: false,
        }
    );

    const options = useMemo<Option[]>(() => {
        return dataList.map((d) => ({
            label: d.name,
            value: d.org_id,
        }));
    }, [dataList]);

    const fetchData = async () => {
        try {
            const res = await callApi();
            setDataList(Array.isArray(res) ? res : (res?.data ?? []));
        } catch (err) {
            setDataList([]);
            console.error(err);
        }
    };

    return {
        dataList,
        options,
        loading,
        fetchData,
    };
}
// ========= END VERIFIER PORTAL ===========
